<div class="CeParameterItem-content">
    <span class="CeParameterItem-primary">
        <span class="CeParameterItem-descriptionWrap" [ngClass]="{ 'CeParameterItem-truncate': truncated }">
            <ng-content></ng-content>
            <ng-content select="[ceParameterItemValue]"></ng-content>
        </span>
    </span>
    <span #secondary class="CeParameterItem-secondary">
        <ng-content select="[ceParameterItemSecondary]"></ng-content>
    </span>
</div>
